module.exports = __webpack_public_path__ + "media/images/badges/akt/AKT_BadassLoyaltyProgram_InvertedBadges_116x116_2-ad5a2b74d64c54ddb120d28bef98e5e1.png";